function getStartOfWeek(date) {
  let firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  const value = new Date(date);

  while (value.getDay() !== firstDayOfWeek) {
    value.setDate(value.getDate() - 1);
  }

  return value;
}

export { getStartOfWeek };